export const TERMS_AGREE = 'termsAgree';
export const PARTICIPATION_TYPE = 'participationType';

export const FIELD_KONTUR_FOCUS = "konturFocus";

export const STATUS_NO_ACCESS = 'noAccess';

export const INPUT_TYPE_TEXT = 'text';
export const INPUT_TYPE_TEXTAREA = 'textarea';
export const INPUT_TYPE_SELECT = 'select';
export const INPUT_TYPE_SELECT_OTHER = 'select-other';
export const INPUT_TYPE_SELECT_SEARCH = 'select-search';
export const INPUT_TYPE_CHECKBOX = 'checkbox';
export const INPUT_TYPE_TEL = 'tel';
export const INPUT_TYPE_TIME = 'time';
export const INPUT_TYPE_DATE = 'date';
export const INPUT_TYPE_DISCLAIMER = 'disclaimer';

export const INPUT_PROPS_MIN = 'min';
export const INPUT_PROPS_MAX = 'max';
export const INPUT_PROPS_REGEXP = 'regexp';
export const INPUT_PROPS_PATTERN = 'pattern';
